// Formatação de data e hora para as telas do comitê — UM lugar só.
//
// Pedido do operador (2026-08-13): "desejo tudo com data e hora", substituindo a
// semana ISO que as telas exibiam.
//
// POR QUE ISTO EXISTE COMO MÓDULO. Ao atender o pedido eu escrevi o mesmo
// formatador QUATRO vezes — `dataHoraLonga` no CaseDetailPage, `quando` no
// HistoricoPanel, `quandoClass` no ClassificacoesPanel, e mais um no
// MessageComposer. Quatro cópias de uma regra de apresentação divergem no
// primeiro ajuste (alguém troca `2-digit` por `numeric` em uma e as telas passam
// a discordar sobre a mesma denúncia), e o repo já registrou a lição em
// §"a contagem de cópias de uma regra é parte do diagnóstico".
//
// ⚠️ FALLBACK COM TESTEMUNHA. `epochMs` ausente é significado, não erro: as
// entradas gravadas antes desta mudança realmente não têm hora, e as do
// DENUNCIANTE nunca terão (a hora fina do lado dele é o vetor que o LT-01
// fechou — ver `selarMensagem` no core). Nesses casos a função devolve a SEMANA,
// que é o que se sabe de fato. O que ela nunca faz é fabricar `00:00` a partir de
// ausência: isso tornaria "não temos a hora" indistinguível de "foi à meia-noite"
// (§"fallback plausível esconde ausência").

const BASE: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

/**
 * Data e hora de `epochMs`, ou a `semana` quando não há hora registrada.
 *
 * `segundos: true` para a TRILHA DE AUDITORIA (histórico, classificações): dois
 * atos do rito podem cair no mesmo minuto e a ordem entre eles é a pergunta que a
 * `LGP-02` faz na análise de retaliação. Fora da trilha, segundo é ruído.
 *
 * Fuso do navegador, de propósito: quem lê é membro do comitê no Brasil e o ato é
 * de pessoa nomeada em ata.
 *
 * Devolve `''` só quando não há NENHUM dos dois — a tela decide se esconde a
 * linha. Nunca inventa horário.
 */
export function dataHora(
  epochMs: number | null | undefined,
  semana?: string | null,
  opts?: { segundos?: boolean },
): string {
  if (epochMs !== null && epochMs !== undefined && Number.isFinite(epochMs)) {
    return new Date(epochMs).toLocaleString('pt-BR', {
      ...BASE,
      ...(opts?.segundos === true ? { second: '2-digit' } : {}),
    });
  }
  return semana ?? '';
}
